import styles from './ParticipantBadge.module.css';

const ParticipantBadge = ({ name }: { name: string }) => {
  if (!name) return null;
  return (
    <div className={styles.participantBadge}>
      <span className={styles.participantName}>{name}</span>
    </div>
  );
};

export default ParticipantBadge;
